import { Location } from './location';
import { MobileBaseObject } from "./mobile-base-object";
import { Availability } from './availability';

export interface IActivity extends MobileBaseObject {
  state: string;
  dateKey: string;
  actorID: string;
  startLocationID: string;
  startLocation: Location;
  endLocationID: string;
  endLocation: Location;
  userMappingID: string;
  availabilityID: string;
  start: Date;
  duration: string;
  status: string;
  description: string;
  comment: string;
  modifiedBy: string;
  started: Date;
  ended: Date;
  availability: Availability;
}

export class Activity extends MobileBaseObject implements IActivity {

  public state: string;
  public dateKey: string;
  public actorID: string;
  public startLocationID: string;
  public startLocation: Location;
  public endLocationID: string;
  public endLocation: Location;
  public userMappingID: string;
  public availabilityID: string;
  public start: Date;
  public duration: string;
  public status: string;
  public description: string;
  public comment: string;
  public modifiedBy: string;
  public started: Date;
  public ended: Date;
  public availability: Availability;

  public constructor(
    activity: Partial<IActivity>
  ) {
    super();

    this.state = activity.state;
    this.dateKey = activity.dateKey;
    this.actorID = activity.actorID;
    this.startLocationID = activity.startLocationID;
    this.endLocationID = activity.endLocationID;
    this.userMappingID = activity.userMappingID;
    this.availabilityID = activity.availabilityID;
    this.start = activity.start ? new Date(activity.start) : activity.start;
    this.duration = activity.duration;
    this.status = activity.status;
    this.description = activity.description;
    this.comment = activity.comment;
    this.modifiedBy = activity.modifiedBy;
    this.started = activity.started ? new Date(activity.started) : activity.started;
    this.ended = activity.ended ? new Date(activity.ended) : activity.ended;
    this.availability = activity.availability;

    this.startLocation = activity.startLocation;
    this.endLocation = activity.endLocation;

    this.id = activity.id;
    this.createdAt = activity.createdAt ? new Date(activity.createdAt) : activity.createdAt;
    this.updatedAt = activity.updatedAt ? new Date(activity.updatedAt) : activity.updatedAt;
  }
}
